import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap, switchMapTo } from "rxjs/operators";
import { selectContractCooldownTime } from "../../../selectors/selectContractInfo";
import { utilTick } from "../../../utils/utilTick";
import { utilTime } from "../../../utils/utilTime";
import { TypeActionApp } from "../../app/actionApp";
import { actionContractFinishCooldown } from "../../market/actionContractInfo";
export var epicTimeMarketCooldown = function (action$, state$) {
    return action$.pipe(ofType(TypeActionApp.Init), switchMapTo(utilTick.second$), switchMap(function () {
        var actions = [];
        var marketRemainingTime = selectContractCooldownTime();
        if (marketRemainingTime.cooldownTime) {
            var timeLeft = utilTime.secondsLeftTill(marketRemainingTime.cooldownTime);
            if (timeLeft <= 0) {
                actions.push(actionContractFinishCooldown());
            }
        }
        return from(actions);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/time/epics/epicTimeMarketCooldown.ts
// module id = 2436
// module chunks = 3